import './App.scss'

import { InteractionType, IPublicClientApplication } from '@azure/msal-browser'
import { MsalAuthenticationTemplate, MsalProvider } from '@azure/msal-react'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { Provider as JotaiProvider } from 'jotai/react'
import { useHydrateAtoms } from 'jotai/react/utils'
import { DevTools } from 'jotai-devtools'
import { queryClientAtom } from 'jotai-tanstack-query'

// import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { loginRequest } from '@/authConfig'
import { ErrorComponent } from '@/components/Error'
import { Loading } from '@/components/Loading'
import { Debug } from '@/pages/components/Debug.tsx'
import { router } from '@/routes'
import { store } from '@/store'

import PageLayout from './components/PageLayout'
import { Provider } from './Provider'
import { queryClient } from './QueryClient'

if (process.env.NODE_ENV !== 'production') {
    import('jotai-devtools/styles.css')
}

interface IAppProps {
    pca: IPublicClientApplication
}

const HydrateAtoms = ({ children }: { children: React.ReactNode }): React.ReactNode => {
    useHydrateAtoms([[queryClientAtom, queryClient]])
    return children
}

const App = ({ pca }: IAppProps) => {
    const authRequest = {
        ...loginRequest,
    }

    return (
        <Provider>
            <MsalProvider instance={pca}>
                <MsalAuthenticationTemplate
                    interactionType={InteractionType.Redirect}
                    authenticationRequest={authRequest}
                    errorComponent={ErrorComponent}
                    loadingComponent={Loading}
                >
                    <QueryClientProvider client={queryClient}>
                        <JotaiProvider store={store}>
                            <DevTools store={store} />
                            <HydrateAtoms>
                                <PageLayout>
                                    <RouterProvider router={router} />
                                    <Debug />
                                </PageLayout>
                            </HydrateAtoms>
                        </JotaiProvider>
                        {/* <ReactQueryDevtools initialIsOpen={false} /> */}
                    </QueryClientProvider>
                </MsalAuthenticationTemplate>
            </MsalProvider>
        </Provider>
    )
}

export default App
